/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useXAxis, useXScale, useYScale } from "@mui/x-charts";
import { useLineSeries } from "@mui/x-charts/hooks/useSeries";
import * as d3Shape from "@mui/x-charts-vendor/d3-shape";
import { Fragment } from "react";

type Props = {
    limit: number;
    forecast: { y: number }[];
};

/***
 * Based on MUI X Chart Line Example:
 * https://mui.com/x/react-charts/line-demo/#line-with-forecast
 ***/
export const ConsumptionProjectedArea = (props: Props) => {
    const { limit, forecast } = props;

    const lineSeries = useLineSeries();
    const xAxis = useXAxis();
    const xScale = useXScale();
    const yScale = useYScale();

    const xAxisData: number[] = xAxis.data?.slice(limit) ?? [];

    if (!yScale) {
        return null;
    }

    const consumptionSeries = lineSeries?.series
        ? Object.values(lineSeries.series).filter((s) =>
              s.id.toString().startsWith("consumption")
          )
        : [];

    return (
        <Fragment>
            {consumptionSeries.map((series: any) => {
                const data = xAxisData.map((v, i) => ({
                    x: v,
                    y0: 0,
                    y1: forecast[i].y,
                }));

                const path = d3Shape
                    .area<(typeof data)[number]>()
                    .x((d) => xScale(d.x)!)
                    .y0((d) => yScale(d.y0 + 10)!)
                    .y1((d) => yScale(d.y1 + 10)!)(data)!;

                return (
                    <path
                        key={`forecast-area-${series.id}`}
                        d={path}
                        fill="rgba(255, 255, 255, 0.15)"
                    />
                );
            })}
        </Fragment>
    );
};
